import React, { useState } from 'react'
import { TabsProps } from '.'
import { Tab, TabsContainer } from './Tabs.styled'

const Tabs = ({ types, defaultChecked, onPressed }: TabsProps) => {
  const [active, setActive] = useState<number>(
    defaultChecked ? defaultChecked : 0
  )

  const handlePress = (press: number) => {
    setActive(press)
    onPressed(press)
  }

  return (
    <TabsContainer>
      {types.map((type, index) => (
        <Tab
          key={type}
          active={active === index}
          onClick={() => handlePress(index)}>
          {type}
        </Tab>
      ))}
    </TabsContainer>
  )
}
export default Tabs
